const SectionTitle = ({ tag, title, subtitle, align = "center" }) => (
  <div className={`section-head ${align === "center" ? "center" : ""}`}>
    {tag && <span className="section-tag">{tag}</span>}
    <h2 className="section-title">{title}</h2>
    {subtitle && <p className="section-sub">{subtitle}</p>}
  </div>
);

export default SectionTitle;